
import { defineComponent } from 'vue'
import PageContent from '@/compontents/page-content/index'
import { contentConfig } from './config/content.config'
export default defineComponent({
  name: 'goods',
  setup() {
    return {
      contentConfig
    }
  },
  components: {
    PageContent
  }
})
